/// <reference path="../../../node_modules/jquery-validation/dist/jquery.validate.js" />
/// <reference path="../../../node_modules/jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive.js" />

$(function () {

    'use strict';
    init();

    function init() {
        setFileName();
        setupContactForm();
        setupMap();
        setupCareersForm();
    }

    function setFileName() {
        $('#file').change(function () {
            var f = this.files[0];
            var name = f.name;
            $('.upload-path').attr("placeholder", name);
        });
    }

    function setupMap() {
        let markerCount = 0;
        let mapComponent = document.getElementById("map");

        let autocomplete = new google.maps.places.Autocomplete(
            document.getElementById("autocomplete"),
            {
                componentRestrictions: { 'country': ['BR'] },
                fields: ['geometry']
            }
        );
        autocomplete.addListener("place_changed", onPlaceChanged);

        let mapa = new google.maps.Map(mapComponent,
            {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false
            });

        let bounds = new google.maps.LatLngBounds();

        function configMap() {
            if (markerCount == 0) {
                addMarker(mapComponent.dataset.defaultlatitude, mapComponent.dataset.defaultlongitude);
            }
            if (markerCount > 1) {
                mapa.fitBounds(bounds);
            }
            else {
                mapa.setCenter(bounds.getCenter());
                mapa.setZoom(10);
            }
        }

        let representantPin;
        let storePin;
        $.get("/contato/GoogleMaps").done(function (data) {
            representantPin = data.representantPin;
            storePin = data.storePin;
            if (data.stores != null) {
                data.stores.forEach(addressList => {
                    addMarker(addressList.GoogleMapsAddress.Latitude.Text, addressList.GoogleMapsAddress.Longitude.Text,
                        [
                            addressList.GoogleMapsAddress.Name.Text,
                            addressList.GoogleMapsAddress.Address.Text,
                            addressList.GoogleMapsAddress.Phone.Text,
                            addressList.GoogleMapsAddress.Email.Text
                        ],
                        addressList.GoogleMapsAddress.PinType.Text);
                });
            }
            configMap();
        });

        function onPlaceChanged() {
            let place = autocomplete.getPlace();
            if (place.geometry) {
                let searchMarker = new google.maps.Marker({
                    position: place.geometry.location,
                    map: mapa
                });
                mapa.setCenter(place.geometry.location);
            }
        }

        function addMarker(lat, lng, content, pin) {
            if (!isNaN(Number(lat)) && Number(lat) != 0 && !isNaN(Number(lng)) && Number(lng) != 0) {
                let pinUrl = pin == "Store" ? storePin : representantPin;
                let marker = new google.maps.Marker({
                    position: { lat: Number(lat), lng: Number(lng) },
                    map: mapa,
                    icon: {
                        url: pinUrl
                    },
                });
                bounds.extend(marker.position);
                markerCount++;

                if (content) {
                    let info = new String();
                    content.forEach(data => {
                        if (data != null) {
                            info = info + ('<div>' + data + '</div>');
                        }
                    });

                    if (info.length != 0) {
                        let detailWindow = new google.maps.InfoWindow({
                            content: info
                        });

                        marker.addListener("click", () => {
                            detailWindow.open(mapa, marker);
                        });
                    }
                }
            }
        }
    }

    function setupContactForm() {
        $("#contact-form").off("submit").submit(function (e) {
            e.preventDefault();

            let form = $(this);

            $("#contact-form-error-message").addClass("d-none");

            if ($(form).valid()) {
                disableForm(form);
                $.post("/contato", form.serialize())
                    .done(function () {
                        clearForm(form);
                        $("#contact-form-success-message").removeClass("d-none");
                    })
                    .fail(function () {
                        enableForm(form);
                        $("#contact-form-error-message").removeClass("d-none");
                    });
            } else {
                enableForm(form);
            }
        });
    }

    function setupCareersForm() {
        $("#careers-form").off("submit").submit(function (e) {
            e.preventDefault();

            let form = $(this);

            $("#careers-form-error-message").addClass("d-none");

            if ($(form).valid()) {
                disableForm(form);

                let formData = new FormData(this);
                $.ajax({
                    url: $(form).attr("action"),
                    type: 'POST',
                    data: formData,
                    success: function (data) {
                        if (data.ok) {
                            clearForm(form);

                            $("#careers-form-success-message").removeClass("d-none");
                        } else {
                            $("#careers-form-wrapper").html(data);

                            setupCareersForm();
                        }
                    },
                    error: function () {
                        enableForm(form);

                        $("#careers-form-error-message").removeClass("d-none");
                    },
                    cache: false,
                    contentType: false,
                    processData: false
                });
            } else {
                enableForm(form);
            }
        })
    }

    function disableForm(form) {
        let button = form.find("button");
        let buttonText = button.find("span");
        let spinner = button.find(".fancybox-loading");

        spinner.removeClass("d-none");
        buttonText.addClass("d-none");
        $(button).prop("disabled", "true");
    }

    function enableForm(form) {
        let button = form.find("button");
        let buttonText = button.find("span");
        let spinner = button.find(".fancybox-loading");

        spinner.addClass("d-none");
        buttonText.removeClass("d-none");
        $(button).removeAttr("disabled");
    }

    function clearForm(form) {
        form[0].reset();

        if ($(form).find("input[type=file]").length !== 0) {
            $(form).find("input[type=file]")[0].value = null;
            $(form).find(".upload-path").val("").attr("placeholder", "");;
        }

        enableForm(form);
    }
});